import {send} from "../../../fetchData";

/** Проверяет отображать ли укороченную версию хлебных крошек при покупке курса
 * @param {Array} listPage - список страниц с api
 * @returns {Boolean} является ли данная версия обрезанной
* */
let checkShowSlicedGKHeader = (listPage) => {
  if (!listPage) return false;

  let acceptableValues = ['select_tariff', 'pay', 'fill_profile_info', 'confirm_email'];
  let lengthArraysAreEqual = listPage.length === acceptableValues.length;
  let arraysAreEqual = listPage.every((element, index) => element === listPage[index]);

  return lengthArraysAreEqual && arraysAreEqual;
};

/** Получить допустимые шаги маршрутизации
 * @param {Number} idCourse - id курса
 * @returns {Promise}
 * */
let getApiAcceptableSteps = (idCourse) => {
  return new Promise((resolve, reject) => {
    let data = {
      module: 'get_buy_steps',
      course_id: idCourse,
    };

    send
      .post('course.php', data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

export { checkShowSlicedGKHeader, getApiAcceptableSteps };